import frame_0_0 from './frame_0_0.png'
import frame_1_0 from './frame_1_0.png'
import frame_0_1 from './frame_0_1.png'
import frame_1_1 from './frame_1_1.png'

export const SECTIONS = [
    [frame_0_0, frame_0_1],
    [frame_1_0, frame_1_1]
];
